<footer class="container page-footer font-small blue pt-0">
  <!-- Footer padding -->
  <div class="footer-padding w-100 clearfix"></div>
  <!-- Footer Links -->
  <div class="container-fluid text-center footer desktop text-md-left d-none d-md-block">
    <hr class="d-none d-md-block" />

    <!-- Grid row -->
    <div class="row indent">
      <!-- Grid column -->
      <div class="col-lg-1 col-md-2 col-sm-12 mb-md-3 mb-2">
        <a href="https://links.themyersbriggs.com/gm2wecta" class="nav-footer-link" target="_blank">Support</a>
      </div>
      <!-- Grid column -->
      <!-- Grid column -->
      <div class="col-lg-1 col-md-2 col-sm-12 mb-md-3 mb-2">
        <a href="https://links.themyersbriggs.com/9saek9kk" class="nav-footer-link" target="_blank">Privacy Policy</a>
      </div>
      <!-- Grid column -->
      <!-- Grid column -->
      <div class="col-lg-1 col-md-2 col-sm-12 mb-md-3 mb-2">
        <a href="https://www.mbtionline.com/Legal#terms" class="nav-footer-link" target="_blank">Terms</a>
      </div>
      <!-- Grid column -->

      <hr class="clearfix w-100 d-md-none pb-3" />

      <!-- Grid column -->
      <div class="copyright col-lg-9 col-md-6 col-sm-12 mt-9 text-md-end">
        <!-- Content -->
        <span>&copy; {{ currentYear }} The Myers-Briggs Company</span>
      </div>
      <!-- Grid column -->
    </div>
    <!-- Grid row -->
  </div>
  <div class="text-center footer mobile d-md-none w-100">
    <hr />
    <div class="row w-100">
      <div class="text-center" [ngClass]="isTeamLeader ? 'col-3' : 'col-4'">
        <a href="/results" routerLink="/results" class="nav-link sticky-menu" routerLinkActive="nav-footerlink-active" #resultLink="routerLinkActive"
          ><img
            src="{{ resultLink.isActive ? 'assets/images/icons/your-results-selected.svg' : 'assets/images/icons/your-results.svg' }}"
            alt="Your Results"
          /><br /><span>Your Results</span></a
        >
      </div>
      <div class="text-center" [ngClass]="isTeamLeader ? 'col-3' : 'col-4'">
        <a href="/team" routerLink="/team" class="nav-link sticky-menu" routerLinkActive="nav-footerlink-active" #teamLink="routerLinkActive"
          ><img
            src="{{ teamLink.isActive ? 'assets/images/icons/your-team-selected.svg' : 'assets/images/icons/your-team.svg' }}"
            alt="Your Team"
          /><br />Your Team</a
        >
      </div>
      <div class="text-center" [ngClass]="isTeamLeader ? 'col-3' : 'col-4'">
        <a href="/learn" routerLink="/learn" class="nav-link sticky-menu" routerLinkActive="nav-footerlink-active" #coursesLink="routerLinkActive"
          ><img
            src="{{ coursesLink.isActive ? 'assets/images/icons/courses-selected.svg' : 'assets/images/icons/courses.svg' }}"
            alt="Courses"
          /><br />Courses</a
        >
      </div>
      <div class="col-3 text-center" *ngIf="isTeamLeader">
        <a href="/manage" routerLink="/manage" class="nav-link sticky-menu" routerLinkActive="nav-footerlink-active" #manageLink="routerLinkActive"
          ><img
            src="{{ manageLink.isActive ? 'assets/images/icons/manage-team-selected.svg' : 'assets/images/icons/manage-team.svg' }}"
            alt="Manage Team"
          /><br /><span>Manage Team</span></a
        >
      </div>
    </div>
  </div>

  <!-- Footer Links -->
</footer>
<!-- Footer -->
